import Axios from 'axios';
import moment from 'moment';
import { sleep } from 'src/utils/sleep';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { IS_PAYMENT_METHOD } from 'src/constants/payments';
import { HS_USER_KEYS, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { REFRESH_TOKEN_KEY } from 'src/constants/notifications';
import { API_SERVICE_NAMES } from 'src/constants/apiServiceName';
export const httpClientCancelTokenStatic = Axios.CancelToken;
const httpClient = Axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT
});
const activityHttpClient = Axios.create({
  baseURL: process.env.ACTIVITY_API_ENDPOINT
});
const allocationsHttpClient = Axios.create({
  baseURL: process.env.ALLOCATIONS_API_ENDPOINT
});
const appfolioHttpClient = Axios.create({
  baseURL: process.env.APPFOLIO_API_ENDPOINT
});
const authHttpClient = Axios.create({
  baseURL: process.env.AUTH_API_ENDPOINT
});
const fileHttpClient = Axios.create({
  baseURL: process.env.FILE_API_ENDPOINT
});
const paperCorrespondenceClient = Axios.create({
  baseURL: process.env.PAPER_CORRESPONDENCE_API_ENDPOINT
});
const paymentHttpClient = Axios.create({
  baseURL: process.env.PAYMENT_API_ENDPOINT
});
const propertyHttpClient = Axios.create({
  baseURL: process.env.PROPERTY_API_ENDPOINT
});
const aggreagateHttpClient = Axios.create({
  baseURL: process.env.AGGREGATE_API_ENDPOINT
});
const stripeHttpClient = Axios.create({
  baseURL: process.env.STRIPE_API_ENDPOINT
});
const urjanetHttpClient = Axios.create({
  baseURL: process.env.URJANET_API_ENDPOINT
});
const billAutomationHttpClient = Axios.create({
  baseURL: process.env.BILL_AUTOMATION_API_ENDPOINT
});
const anonymousHttpClient = Axios.create();
let refreshSubscribers = [];
let isTokenRefreshing = false;
let isPreTokenRefreshing = false;
const refreshUrl = '/account/token/refresh';
export const getHTTPClient = apiSource => {
  switch (apiSource) {
    case API_SERVICE_NAMES.ACTIVITY:
      return activityHttpClient;
    case API_SERVICE_NAMES.ALLOCATIONS:
      return allocationsHttpClient;
    case API_SERVICE_NAMES.APPFOLIO:
      return appfolioHttpClient;
    case API_SERVICE_NAMES.AUTH:
      return authHttpClient;
    case API_SERVICE_NAMES.FILE:
      return fileHttpClient;
    case API_SERVICE_NAMES.PAYMENT:
      return paymentHttpClient;
    case API_SERVICE_NAMES.PROPERTY:
      return propertyHttpClient;
    case API_SERVICE_NAMES.PAPER_CORRESPONDENCE:
      return paperCorrespondenceClient;
    case API_SERVICE_NAMES.AGGREGATE:
      return aggreagateHttpClient;
    case API_SERVICE_NAMES.STRIPE:
      return stripeHttpClient;
    case API_SERVICE_NAMES.URJANET:
      return urjanetHttpClient;
    case API_SERVICE_NAMES.BILL_AUTOMATION:
      return billAutomationHttpClient;
    case API_SERVICE_NAMES.ANONYMOUS:
      return anonymousHttpClient;
    default:
      return httpClient;
  }
};
export const isHttpClientCancel = Axios.isCancel;
export const isHttpClientError = Axios.isAxiosError;
const initializeAccessToken = (token, apiSource) => {
  getHTTPClient(apiSource).defaults.headers.common[
  // eslint-disable-next-line @typescript-eslint/dot-notation
  'Authorization'] = "Bearer ".concat(token);
};
const initApiKeysAfterRefresh = (AT, EO) => {
  initializeAccessToken(AT);
  initializeAccessToken(AT, API_SERVICE_NAMES.ACTIVITY);
  initializeAccessToken(AT, API_SERVICE_NAMES.ALLOCATIONS);
  initializeAccessToken(AT, API_SERVICE_NAMES.AUTH);
  initializeAccessToken(AT, API_SERVICE_NAMES.FILE);
  initializeAccessToken(AT, API_SERVICE_NAMES.PAYMENT);
  initializeAccessToken(AT, API_SERVICE_NAMES.PROPERTY);
  initializeAccessToken(AT, API_SERVICE_NAMES.PAPER_CORRESPONDENCE);
  initializeAccessToken(AT, API_SERVICE_NAMES.AGGREGATE);
  initializeAccessToken(AT, API_SERVICE_NAMES.STRIPE);
  initializeAccessToken(AT, API_SERVICE_NAMES.URJANET);
  initializeAccessToken(AT, API_SERVICE_NAMES.BILL_AUTOMATION);
  initializeAccessToken(AT, API_SERVICE_NAMES.APPFOLIO);
  // initializeAccessToken(AT, API_SERVICE_NAMES.ANONYMOUS);

  localStorage.setItem(AUTH_TOKEN_KEYS.accessToken, AT);
  localStorage.setItem(AUTH_TOKEN_KEYS.expiresOn, EO);
  localStorage.setItem(REFRESH_TOKEN_KEY, 'true');
  window.dispatchEvent(new StorageEvent('triggerStorageTokenEventHandler'));
};
const startErrorRoad = () => {
  var _searchParams$get;
  localStorage.removeItem(AUTH_TOKEN_KEYS.accessToken);
  localStorage.removeItem(AUTH_TOKEN_KEYS.expiresOn);
  localStorage.removeItem(AUTH_TOKEN_KEYS.refreshToken);
  localStorage.removeItem(AUTH_TOKEN_KEYS.session);
  localStorage.removeItem(AUTH_TOKEN_KEYS.requireMfa);
  localStorage.removeItem(AUTH_TOKEN_KEYS.demoPropertyMode);
  localStorage.removeItem(USER_SETTINGS_KEYS.company);
  localStorage.removeItem(USER_SETTINGS_KEYS.companyName);
  localStorage.removeItem(IS_PAYMENT_METHOD);
  localStorage.removeItem('livable_user_role');
  localStorage.removeItem('livable_property_id');
  localStorage.removeItem('livable_portfolio_id');
  localStorage.removeItem('livable_user_email_confirmed');
  localStorage.removeItem('livable_user_phone_confirmed');
  localStorage.removeItem(HS_USER_KEYS.email);
  localStorage.removeItem(HS_USER_KEYS.token);
  const searchParams = new URLSearchParams(window.location.search);
  const email = searchParams.get('email') ? (_searchParams$get = searchParams.get('email')) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.replace(' ', '+') : null;
  const confirmationCode = searchParams.get('confirmationCode');
  if (email && confirmationCode) {
    window.location.reload();
    return;
  }
  window.location.href = '/login';
};
const onRefreshed = token => {
  refreshSubscribers.map(callback => callback(token));
};
const subscribeTokenRefresh = callback => {
  refreshSubscribers.push(callback);
};
const preRefreshAccessToken = async () => {
  return new Promise((resolve, reject) => {
    authHttpClient.post(refreshUrl, {
      refreshToken: localStorage.getItem(AUTH_TOKEN_KEYS.refreshToken)
    }).then(response => {
      if (!response) {
        startErrorRoad();
        return;
      }
      const newAccessToken = response.data.response.accessToken;
      const newExpiresOn = response.data.response.expiresOn;
      initApiKeysAfterRefresh(newAccessToken, newExpiresOn);
      resolve(response);
    }).catch(refreshError => {
      startErrorRoad();
      reject(refreshError);
    });
  });
};
[activityHttpClient, allocationsHttpClient, appfolioHttpClient, authHttpClient, fileHttpClient, paymentHttpClient, propertyHttpClient, paperCorrespondenceClient, aggreagateHttpClient, stripeHttpClient, urjanetHttpClient, billAutomationHttpClient].map(api => {
  api.interceptors.request.use(async config => {
    if (config.url !== refreshUrl && localStorage.getItem(AUTH_TOKEN_KEYS.session) === 'null' && localStorage.getItem(AUTH_TOKEN_KEYS.refreshToken) && localStorage.getItem(AUTH_TOKEN_KEYS.expiresOn) && moment(localStorage.getItem(AUTH_TOKEN_KEYS.expiresOn)).utc().valueOf() < moment.utc().valueOf()) {
      if (!isPreTokenRefreshing) {
        isPreTokenRefreshing = true;
        await preRefreshAccessToken();
        isPreTokenRefreshing = false;
      }
      for (let count = 0; count < 60; count++) {
        if (!isPreTokenRefreshing) {
          break;
        } else if (count === 59) {
          startErrorRoad();
        }
        await sleep(500);
      }
      return config;
    } else {
      return config;
    }
  }, error => {
    return Promise.reject(error);
  });
  api.interceptors.response.use(response => response, error => {
    var _error$response, _error$response2;
    if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== 401 || (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 401 && (!localStorage.getItem(AUTH_TOKEN_KEYS.refreshToken) || localStorage.getItem(AUTH_TOKEN_KEYS.refreshToken) === 'null')) {
      return Promise.reject(error);
    }
    return new Promise((resolve, reject) => {
      if (!isTokenRefreshing) {
        isTokenRefreshing = true;
        return authHttpClient.post(refreshUrl, {
          refreshToken: localStorage.getItem(AUTH_TOKEN_KEYS.refreshToken)
        }).then(response => {
          if (!response) {
            startErrorRoad();
            return;
          }
          isTokenRefreshing = false;
          const newAccessToken = response.data.response.accessToken;
          const newExpiresOn = response.data.response.expiresOn;
          initApiKeysAfterRefresh(newAccessToken, newExpiresOn);
          onRefreshed(newAccessToken);
          error.response.config.headers.Authorization = "Bearer ".concat(newAccessToken);
          api(error.response.config).then(cResponse => resolve(cResponse), cError => reject(cError));
          setTimeout(() => {
            refreshSubscribers = [];
            localStorage.setItem(REFRESH_TOKEN_KEY, 'true');
            window.dispatchEvent(new Event('storage'));
          }, 1000);
        }).catch(refreshError => {
          startErrorRoad();
          reject(refreshError);
        });
      }
      subscribeTokenRefresh(idToken => {
        error.response.config.headers.Authorization = "Bearer ".concat(idToken);
        api(error.response.config).then(cResponse => resolve(cResponse), cError => reject(cError));
      });
    });
  });
});